import { render, staticRenderFns } from "./PrazoPagamentoCadastroModal.vue?vue&type=template&id=38143671&scoped=true"
import script from "./PrazoPagamentoCadastroModal.vue?vue&type=script&lang=js"
export * from "./PrazoPagamentoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamentoCadastroModal.vue?vue&type=style&index=0&id=38143671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38143671",
  null
  
)

export default component.exports